import React from "react"
import moment from "moment"
import FontAwesome from "react-fontawesome"

export default function CreatedOnDate({ createdOn }) {

  return (
    <p title="Created On" className='gray font-size-13 align-right'>
      <FontAwesome name='calendar-check-o' /> Created On: {
      createdOn ? moment(createdOn).format('lll') : '' }
    </p>
  )
}


// WEBPACK FOOTER //
// ./src/components/fragments/CreatedOnDate.js